import { useState, useEffect, useMemo } from 'react';
import Lightbulb from './LightBulb';

export default function HeroSection() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [typingSpeed, setTypingSpeed] = useState(150);
  const [currentColorIndex, setCurrentColorIndex] = useState(0);

  // Words and colors array
  const words = useMemo(() => ['collaborator', 'creator', 'leader', 'strategist', 'problem-solver', 'visionary'], []);
  const colors = useMemo(() => [
    'text-brand-orange', 
    'text-brand-yellow', 
    'text-brand-teal', 
    'text-brand-green', 
    'text-brand-purple', 
    'text-brand-pink', 
    'text-brand-blue'], 
  []);
  
  useEffect(() => {
    const handleTyping = () => {
      const fullText = words[currentWordIndex];
      if (!isDeleting) {
        setCurrentText(fullText.substring(0, currentText.length + 1));
        if (currentText === fullText) {
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        setCurrentText(fullText.substring(0, currentText.length - 1));
        if (currentText === '') {
          setIsDeleting(false);
          setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
          setCurrentColorIndex((prevIndex) => (prevIndex + 1) % colors.length); // Change color when word changes
        }
      }
      setTypingSpeed(isDeleting ? 75 : 150);
    };

    const typingTimer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(typingTimer);
  }, [currentText, isDeleting, typingSpeed, currentWordIndex, words, colors]);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      setMousePosition({ x: event.pageX, y: event.pageY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <section className="flex flex-col items-center justify-center min-h-screen text-white text-center px-4 sm:px-8">
      <div className="max-w-[600px]">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight mb-6 text-white font-chalk">
          Hi, my name is <span className="text-orange-400">Eric</span>
        </h1>
        <p className="text-xl sm:text-2xl md:text-3xl font-light font-chalk">
          I am a{' '}
          <span className={`font-semibold ${colors[currentColorIndex]}`}>
            {currentText}
            <span className="blinking-cursor">|</span>
          </span>
        </p>
      </div>
      <div className="mt-10">
        <Lightbulb mousePosition={mousePosition} />
      </div>
    </section>
  );
}
